module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/what-to-write-in-a-wedding-card-37b2e3b725d200e7b7683448ddd5835c.jpg";